module.exports = __webpack_public_path__ + "img/3-noparticipated.6e733a8f.png";